module.exports = __webpack_public_path__ + "lc.svg?ee66a25b783be4356716a07a25ba69df";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/lc.svg
// module id = 1110
// module chunks = 27